  <button mat-icon-button matTooltip="Restablecer valores de filtro" class="bounce-icon small-icon-btn">
    <mat-icon class="bounce-icon">cleaning_services</mat-icon>
  </button>
